export const config = {
    baseURL:"https://feccqroo.sinoep-ag.com/api/"
}
